import { API } from '@/services/api-core.service'

export const customerService = {
  /**
   * Get customers list
   * @param {Object} queryParams
   * @param {Object} body
   * @return {Promise<*|{errors}|{error}>}
   */
  searchCustomers(queryParams = null, body = null) {
    return API.request('GET', 'api/customers', queryParams, body, true)
  },
  /**
   * Create a customer
   * @param {Object} queryParams
   * @param {Object} body
   * @return {Promise<*|{errors}|{error}>}
   */
  createCustomer(queryParams = null, body = null) {
    return API.request('POST', 'api/customers', queryParams, body, true)
  },
  /**
   * Get customer info
   * @param {string} customerId
   * @param {boolean} loader
   * @return {Promise<*|{errors}|{error}>}
   */
  async getCustomer(customerId, loader = false) {
    return await API.request('GET', `api/customers/${customerId}`, null, null, loader)
  },
  /** Get dynamic list customers content
   * @returns {Promise<*|{errors}|{error}>}
   */
  async checkRecipient(email) {
    return await API.request('GET', 'api/customers/email/check', { email }, null, true, false)
  }
}
